import { connect } from 'react-redux'
import { login } from '../../actions/auth'
import { closeLoginModal } from '../../actions/modals'
import LoginPopover from './LoginPopover'

const mapStateToProps = (state) => {
    return {
        user: state.user,
        auth: state.auth,
        loginPending: state.auth.pending,
        loginFailed: state.auth.failed,
        loginExpired: state.auth.expired,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        login: (data) => {
            console.log('container')
            dispatch(login(data))
        },
        closeLoginModal: () => {
            dispatch(closeLoginModal())
        }
    }
}

const LoginPopoverContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginPopover)

export default LoginPopoverContainer
